<template>
  <div class="container py-4">
    <!-- Giriş Alanları -->
    <div class="mb-3">
      <label for="name" class="form-label fw-bold">Vefat Eden:</label>
      <input id="name" v-model="name" type="text" class="form-control" />
    </div>
    <div class="mb-3">
      <label for="message" class="form-label fw-bold">Mesaj:</label>
      <input id="message" v-model="message" type="text" class="form-control" />
    </div>
    <div class="mb-3">
      <label for="location" class="form-label fw-bold">Taziye Yeri:</label>
      <input id="location" v-model="location" type="text" class="form-control" />
    </div>
    <div class="mb-3">
      <label for="date" class="form-label fw-bold">Tarih:</label>
      <input id="date" v-model="date" type="text" class="form-control" />
    </div>
    <div class="mb-3">
      <label for="contact" class="form-label fw-bold">İletişim Bilgisi:</label>
      <input id="contact" v-model="contact" type="text" class="form-control" />
    </div>

    <!-- Belge Alanı -->
    <div ref="captureArea" class="certificate-area shadowed">


      <div class="header-text title-with-icons">

        <div>

          <i class="fas fa-ribbon text-white me-2"></i>
          <h4>Vafat Duyurusu</h4>

        </div>

      </div>
      <div class="message-box">
        <p class="name">{{ name }}</p>
        <p class="message">{{ message }}</p>
      </div>

      <!-- Bilgi kutusu -->
      <div class="info-box">
        <p v-if="location"><i class="fas fa-map-marker-alt me-2"></i><strong>Yer : </strong> {{ location }}</p>
        <p v-if="date"><i class="fas fa-calendar-alt me-2"></i><strong>Tarih : </strong> {{date }}</p>
        <p v-if="contact">
          <i class="fas fa-phone-alt me-2"></i><strong>İletişim : </strong>
          <a :href="`tel:${normalizePhone(contact)}`">{{ contact }}</a>
        </p>
      </div>


      <div class="mt-3 text-center">
        <h6 class="dernek_name">Başkent Ağrılılar Eğitim, Kültür ve Sosyal Yardımlaşma Derneği</h6>

        <img src="/img/logo.jpg" alt="Dernek Logosu" style="height: 80px;border-radius: 50%;" class="me-2 mt-2" />
      </div>

    </div>

    <!-- İndirme Butonu -->
    <div class="text-center mt-4">
      <button @click="downloadAsPng" class="btn btn-success">
        PNG Olarak Kaydet
      </button>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import html2canvas from "html2canvas";

const name = ref("");
const location = ref("");
const date = ref("");
const contact = ref("");
const message = ref(
  "Vefat etmiştir. Kendisine Allah'tan rahmet diler, ailesine ve yakınlarına başsağlığı diliyoruz."
);

const captureArea = ref(null);

function normalizePhone(value) {
  return String(value || "").replace(/[^\d+]/g, "");
}

const downloadAsPng = async () => {
  if (!captureArea.value) return;

  const canvas = await html2canvas(captureArea.value, {
    backgroundColor: "#1a1a1a",
    scale: 2,
    useCORS: true,
  });

  const link = document.createElement("a");
  link.download = "taziye-belgesi.png";
  link.href = canvas.toDataURL("image/png");
  link.click();
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Poppins:wght@400;600&display=swap");

.certificate-area {
  position: relative;
  width: 100%;
  max-width: 700px;
  margin: 0 auto;
  padding: 2rem 1.5rem;
  border-radius: 12px;
  background: #1a1a1a;
  color: #f5f5f5;
  font-family: "Poppins", sans-serif;
  text-align: center;
}

/* Gölge efekti */
.shadowed {
  box-shadow: 0 6px 25px rgba(0, 0, 0, 0.7);
}

/* Logo */
.logo-top {
  height: 70px;
  margin-bottom: 1rem;
}

.header-text {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;

}

/* Başlık */
.header-text h4 {
  font-size: 1.2rem;
  font-weight: 500;
  color: #ccc;
  margin-bottom: 0.4rem;
}

.header-text h3 {
  font-size: 1.8rem;
  font-weight: 600;
  color: #e0e0e0;
}

/* Vefat Eden */
.message-box .name {
  font-size: 1.6rem;
  font-weight: 600;
  margin: 1rem 0 0.5rem;
  color: #ffffff;
}

.message-box .message {
  font-size: 1.1rem;
  color: #d1d1d1;
  line-height: 1.5;
}

/* Bilgi kutusu */
.info-box {
  margin-top: 1.5rem;
  padding: 1rem;
  border-top: 2px solid #444;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 8px;
  font-size: 1rem;
  text-align: left;
}

.info-box p {
  margin: 0.4rem 0;
  display: flex;
  align-items: center;
}

.info-box i {
  color: #aaa;
  min-width: 20px;
  text-align: center;
}

/* Dernek ismi */
.footer-text {
  margin-top: 1.8rem;
  justify-content: center;
  align-items: center;
}

.footer-text h6 {
  font-size: 0.95rem;
  color: #bbbbbb;
  font-style: italic;
  font-weight: 500;
}

/* Responsive */
@media (max-width: 600px) {
  .certificate-area {
    padding: 1.5rem 1rem;
  }

  .logo-top {
    height: 55px;
  }

  .header-text h3 {
    font-size: 1.4rem;
  }

  .message-box .name {
    font-size: 1.2rem;
  }

  .message-box .message {
    font-size: 1rem;
  }

  .info-box {
    font-size: 0.9rem;
  }
}

.title-with-icons {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  font-size: 1.8rem;
  font-weight: 600;
  color: #e0e0e0;
}

.title-with-icons i {
  font-size: 4.4rem;
  margin: 16px;

}

.dernek_name {
  width: 50%;
  margin: auto;
  align-self: center;
  color: white;
  text-align: center;
}
</style>
